import { buildRotationItems } from './RotatingWidgetBody';

const STANDARD = 'standard';
const WIDE = 'wide';
const LONG_WIDGET_NAME_LENGTH = 20;
const LONG_ROTATING_CONTENT_LENGTH = 16;

const getValueCount = (values) => {
  if (!Array.isArray(values) || values.length === 0 || values[0] == null) {
    return 0;
  }

  return Object.keys(values[0]).length;
};

export const WIDGET_LAYOUT_VARIANTS = {
  STANDARD,
  WIDE,
};

export const getWidgetLayoutVariant = (widgetDetails, widgetData) => {
  const widgetName = widgetDetails?.WIDGET_NAME?.trim() || '';
  const widgetType = widgetDetails?.TYPE?.toUpperCase();
  const subLabels = Array.isArray(widgetData?.sublabels) ? widgetData.sublabels : [];
  const widgetValues = Array.isArray(widgetData?.values) ? widgetData.values : [];
  const valueCount = getValueCount(widgetValues);
  const rotationItems = widgetType === 'ROTATING' ? buildRotationItems(widgetData) : [];

  const hasLongTitle = widgetName.length > LONG_WIDGET_NAME_LENGTH;
  const hasMultiMetricContent = subLabels.length > 1 || valueCount > 1;
  const hasLongRotatingContent = rotationItems.some((item) => {
    const labelLength = String(item?.label || '').trim().length;
    const valueLength = String(item?.value || '').trim().length;

    return labelLength > LONG_ROTATING_CONTENT_LENGTH || valueLength > LONG_ROTATING_CONTENT_LENGTH;
  });

  return hasLongTitle || hasMultiMetricContent || hasLongRotatingContent
    ? WIDE
    : STANDARD;
};
